import { z } from 'zod';
import { CloverGatewayEnvironment } from '../../../types/ipg/clover/clover-gateway-environment.types';

export const CloverGatewayEnvironmentSchema: z.ZodEnum<
    typeof CloverGatewayEnvironment
> = z.enum(CloverGatewayEnvironment);
